module.exports = __webpack_public_path__ + "img/image20.17dfa31d.jpg";